<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.063 10.5H13.5a2.25 2.25 0 01-2.25-2.25V1.687a.188.188 0 00-.188-.187H6.75a3 3 0 00-3 3v15a3 3 0 003 3h10.5a3 3 0 003-3v-8.813a.188.188 0 00-.188-.187zM15.75 18h-7.5a.75.75 0 110-1.5h7.5a.75.75 0 110 1.5zm0-3.75h-7.5a.75.75 0 110-1.5h7.5a.75.75 0 110 1.5z"
      fill="#262626"
    />
    <path
      d="M19.65 8.84L12.91 2.1a.093.093 0 00-.16.065V8.25a.75.75 0 00.75.75h6.085a.094.094 0 00.066-.16z"
      fill="#262626"
    />
  </svg>
</template>

<script>
export default {
  name: 'DocumentIcon',
};
</script>
